import React from 'react'

const baseClass = 'inline'

const SVG = ({
  name,
  size = 32,
  color = '#4299e1',
  lineWidth = 2,
  className = '',
}) => {
  return {
    wrench: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2045 11.6583C15.4503 12.3573 16.9272 12.284 17.8382 11.373C18.6514 10.5598 18.7998 9.29408 18.326 8.15565L16.1604 10.3213C15.9154 10.5663 15.5182 10.5663 15.2733 10.3213L14.0037 9.05175C13.7587 8.80679 13.7587 8.40963 14.0037 8.16466L16.1694 5.99898C15.0309 5.52519 13.7723 5.66662 12.952 6.48689C12.0006 7.43831 11.9579 9.00213 12.7579 10.2786C12.7569 10.2796 12.7558 10.2807 12.7548 10.2817L7.0614 15.9746C6.67078 16.3652 6.67078 16.998 7.0614 17.3887C7.25671 17.584 7.51257 17.6816 7.76843 17.6816C8.02429 17.6816 8.28015 17.584 8.47546 17.3887L14.1688 11.6958C14.1811 11.6835 14.193 11.671 14.2045 11.6583Z"
          fill="curentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.036 20.7959H5.06824C4.28796 20.7959 3.65417 20.1616 3.65417 19.3823V4.41406C3.65417 3.63428 4.28796 3 5.06824 3H20.036C20.8153 3 21.4491 3.63428 21.4491 4.41406V19.3823C21.4491 20.1616 20.8153 20.7959 20.036 20.7959ZM5.06824 4.2002C4.95007 4.2002 4.85339 4.2959 4.85339 4.41406V19.3823C4.85339 19.5 4.95007 19.5957 5.06824 19.5957H20.036C20.1542 19.5957 20.2499 19.5 20.2499 19.3823V4.41406C20.2499 4.2959 20.1542 4.2002 20.036 4.2002H5.06824Z"
          fill="curentColor"
        />
      </svg>
    ),

    user: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M5.121 17.804A13.937 13.937 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
        />
      </svg>
    ),

    shield: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="m9 12 2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 12 2.944a11.955 11.955 0 0 1-8.618 3.04A12.02 12.02 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        />
      </svg>
    ),

    download: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
    ),

    brands: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
        />
      </svg>
    ),

    categories: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2z"
        />
      </svg>
    ),

    product: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M16 11V7a4 4 0 0 0-8 0v4M5 9h14l1 12H4L5 9z"
        />
      </svg>
    ),

    review: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
        />
      </svg>
    ),

    variant: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="m21 10.244-3.886-2.267m-10.239.006L3 10.243M21 10.244l-9 5.25M21 10.244V16.5l-9 5.25M3 10.25l9 5.244M3 10.25v6.25l9 5.25M12 15.494v6.256M17.053 5.197 12 2.25 6.947 5.197m10.106 0L12 8.145m5.053-2.948V9.25L12 12.197m-5.053-7L12 8.145M6.947 5.197V9.25L12 12.197m0-4.052v4.052" />
      </svg>
    ),

    options: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
        />
      </svg>
    ),

    swatch: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
        />
      </svg>
    ),

    template: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
        />
      </svg>
    ),

    world: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),

    pointer: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="m15 15-2 5L9 9l11 4-5 2zm0 0 5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656-2.12 2.122"
        />
      </svg>
    ),

    image: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="m4 16 4.586-4.586a2 2 0 0 1 2.828 0L16 16m-2-2 1.586-1.586a2 2 0 0 1 2.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
        />
      </svg>
    ),

    info: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
        />
      </svg>
    ),

    clipboard: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    ),

    magic: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16 2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
        />
      </svg>
    ),

    emailLink: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        fillRule="evenodd"
        viewBox="0 0 268 239"
      >
        <path
          fill="#FFF"
          d="m135.874.584 129.18 89.964c.078.055.136.131.169.217a3.28 3.28 0 0 1 1.899 2.842V235.73a3.275 3.275 0 0 1-3.158 3.27H4.148a3.274 3.274 0 0 1-3.27-3.157V93.734a3.272 3.272 0 0 1 3.116-3.266L132.128.59a3.28 3.28 0 0 1 3.746-.006Z"
        />
        <path
          fill="#3F3D56"
          fillRule="nonzero"
          d="M264.786 91.399a.466.466 0 0 1-.267-.084L135.34 1.35a2.343 2.343 0 0 0-2.675.004L4.416 91.314a.467.467 0 1 1-.536-.765L132.128.59a3.28 3.28 0 0 1 3.746-.006l129.18 89.964a.467.467 0 0 1-.268.85Z"
        />
        <path
          fill="#E6E6E6"
          fillRule="nonzero"
          d="M17.71 96.303 134.13 3.886l117.172 92.417L135.85 145.34z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M135.85 145.107c-.46 0-.915-.089-1.34-.262l-75.478-31.319v-98.03a3.273 3.273 0 0 1 3.27-3.27H207.1a3.273 3.273 0 0 1 3.27 3.27v98.099l-.142.06-72.997 31.174a3.564 3.564 0 0 1-1.381.278Z"
        />
        <path
          fill="#3F3D56"
          fillRule="nonzero"
          d="M135.85 145.34a3.78 3.78 0 0 1-1.43-.28l-75.622-31.378V15.496a3.507 3.507 0 0 1 3.503-3.504h144.8a3.507 3.507 0 0 1 3.502 3.504v98.253l-73.28 31.295a3.796 3.796 0 0 1-1.473.296Zm-76.118-32.282 75.045 31.139c.7.284 1.484.28 2.18-.013l72.712-31.052V15.496a2.572 2.572 0 0 0-2.569-2.57H62.301a2.572 2.572 0 0 0-2.569 2.57v97.562Z"
        />
        <path
          fill="#3F3D56"
          fillRule="nonzero"
          d="M263.852 90.464h-.094l-53.622 22.897-73.366 31.328a2.366 2.366 0 0 1-1.813.01l-75.692-31.403-54.94-22.794-.083-.038h-.094a3.272 3.272 0 0 0-3.27 3.27V235.73a3.272 3.272 0 0 0 3.27 3.27h259.704a3.272 3.272 0 0 0 3.27-3.27V93.734a3.272 3.272 0 0 0-3.27-3.27Zm2.335 145.266a2.336 2.336 0 0 1-2.335 2.336H4.148a2.336 2.336 0 0 1-2.335-2.336V93.734a2.34 2.34 0 0 1 2.246-2.336l55.206 22.907 75.333 31.258c.815.331 1.73.326 2.541-.014l72.997-31.174 53.81-22.977a2.343 2.343 0 0 1 2.241 2.336V235.73Z"
        />
        <path
          fill="#6C63FF"
          fillRule="nonzero"
          d="M129.575 107.353a7.604 7.604 0 0 1-4.575-1.52l-.082-.061-17.23-13.193a7.655 7.655 0 1 1 9.311-12.153l11.161 8.558 26.375-34.396a7.655 7.655 0 0 1 10.733-1.417l-.164.222.168-.219a7.664 7.664 0 0 1 1.417 10.733l-31.023 40.459a7.658 7.658 0 0 1-6.09 2.987ZM82.272 211.747h-60.46a2.825 2.825 0 1 1 0-5.649h60.46a2.825 2.825 0 1 1 0 5.65ZM43.503 199.603H21.811a2.825 2.825 0 1 1 0-5.65h21.692a2.825 2.825 0 1 1 0 5.65Z"
        />
        <path
          fill="#E6E6E6"
          fillRule="nonzero"
          d="M70.888 24.082a.422.422 0 0 1 .544.108l6.683 6.61a7.669 7.669 0 0 0-1.483 1.378 7.822 7.822 0 0 0-1.122 1.735 3.104 3.104 0 0 0-.274 1.289v8.454a.642.642 0 0 0 .642.643h8.51c.442 0 .878-.092 1.282-.27a7.543 7.543 0 0 0 3.102-2.536l6.626 6.664c.167.128.214.36.11.543a.522.522 0 0 1-.49.326H71.106a.544.544 0 0 1-.544-.543V24.49a.475.475 0 0 1 .326-.408Zm19.69 1.419a.643.643 0 0 1 .899-.009l2.637 2.534a.643.643 0 0 1 .009.917l-4.902 4.902a2.981 2.981 0 0 0-.858 2.342 5.407 5.407 0 0 1-5.387 5.822 3.515 3.515 0 0 1-.536-.025.699.699 0 0 1-.59-.466.715.715 0 0 1 .169-.752l1.712-1.712a1.357 1.357 0 0 0 0-1.916l-1.306-1.311a1.371 1.371 0 0 0-.947-.38c-.359 0-.703.14-.962.388l-1.715 1.716a.71.71 0 0 1-.504.215.738.738 0 0 1-.708-.529 5.4 5.4 0 0 1 5.784-6.018 2.988 2.988 0 0 0 2.355-.868Z"
        />
      </svg>
    ),

    coupon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
        />
      </svg>
    ),

    gift: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M12 8v13m0-13V6a2 2 0 1 1 2 2h-2zm0 0V5.5A2.5 2.5 0 1 0 9.5 8H12zm-7 4h14M5 12a2 2 0 1 1 0-4h14a2 2 0 1 1 0 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"
        />
      </svg>
    ),

    order: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"
        />
      </svg>
    ),

    redirect: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={lineWidth}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
        />
      </svg>
    ),

    upload: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.32568 9.04508C7.13649 6.69118 9.37075 5 12 5C15.3137 5 18 7.68629 18 11C20.2091 11 22 12.7909 22 15C22 17.2091 20.2091 19 18 19H14V16H15.9325C16.3564 16 16.588 15.5056 16.3166 15.1799L12.3841 10.4609C12.1842 10.2211 11.8158 10.2211 11.6159 10.4609L7.68341 15.1799C7.41202 15.5056 7.6436 16 8.06752 16H10V19H7C4.23858 19 2 16.7614 2 14C2 11.4673 3.88316 9.37436 6.32568 9.04508Z"
          fill="currentColor"
        />
      </svg>
    ),

    close: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    ),

    trash: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
        />
      </svg>
    ),

    trash2: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2C4 1.44772 4.44772 1 5 1H19C19.5523 1 20 1.44772 20 2V4C20 4.55228 19.5523 5 19 5H18.9945L18.0522 22.0552C18.0229 22.5852 17.5846 23 17.0537 23H6.94628C6.41543 23 5.97708 22.5852 5.9478 22.0552L5.00552 5H5C4.44772 5 4 4.55228 4 4V2ZM10 2C10 1.72386 10.2239 1.5 10.5 1.5C10.7761 1.5 11 1.72386 11 2V4C11 4.27614 10.7761 4.5 10.5 4.5C10.2239 4.5 10 4.27614 10 4V2ZM13.5 1.5C13.2239 1.5 13 1.72386 13 2V4C13 4.27614 13.2239 4.5 13.5 4.5C13.7761 4.5 14 4.27614 14 4V2C14 1.72386 13.7761 1.5 13.5 1.5ZM16 2C16 1.72386 16.2239 1.5 16.5 1.5C16.7761 1.5 17 1.72386 17 2V4C17 4.27614 16.7761 4.5 16.5 4.5C16.2239 4.5 16 4.27614 16 4V2ZM7.5 1.5C7.22386 1.5 7 1.72386 7 2V4C7 4.27614 7.22386 4.5 7.5 4.5C7.77614 4.5 8 4.27614 8 4V2C8 1.72386 7.77614 1.5 7.5 1.5ZM12 8C11.7239 8 11.5 8.22386 11.5 8.5V19.5C11.5 19.7761 11.7239 20 12 20C12.2761 20 12.5 19.7761 12.5 19.5V8.5C12.5 8.22386 12.2761 8 12 8ZM14.5 8.5C14.5 8.22386 14.7239 8 15 8C15.2761 8 15.5 8.22386 15.5 8.5V19.5C15.5 19.7761 15.2761 20 15 20C14.7239 20 14.5 19.7761 14.5 19.5V8.5ZM9 8C8.72386 8 8.5 8.22386 8.5 8.5V19.5C8.5 19.7761 8.72386 20 9 20C9.27614 20 9.5 19.7761 9.5 19.5V8.5C9.5 8.22386 9.27614 8 9 8Z"
          fill="currentColor"
        />
      </svg>
    ),

    click: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.163 3.3C11.163 3.6 10.863 3.9 10.563 3.9C10.263 3.9 9.96301 3.7 9.96301 3.4V2.6C9.96301 2.3 10.263 2 10.563 2C10.863 2 11.163 2.3 11.163 2.6V3.3ZM19.263 11.2C19.463 11.4 19.763 11.9 19.763 12.6C19.763 15.2 19.2629 17.5 18.5629 18.9L18.763 21.3C18.763 21.5 18.6629 21.7 18.5629 21.8L18.5629 21.8C18.4629 21.9 18.3629 22 18.1629 22H9.56294C9.26294 22 8.96295 21.7 8.96295 21.4C8.96295 19.7 8.16295 18.1 6.76295 17C6.64497 16.9056 6.51586 16.8001 6.37956 16.6887L6.37936 16.6885C5.93803 16.3278 5.42131 15.9055 4.96295 15.6C4.56295 15.3 4.26295 14.9 4.26295 14.4C4.16295 13.9 4.36295 13.5 4.66295 13.1C5.56295 12.2 6.56295 12.1 7.66295 12.9C7.76714 12.9833 7.86699 13.0623 7.9625 13.1379L7.96261 13.138L7.96293 13.1383L7.96294 13.1383L7.96297 13.1383C8.32557 13.4252 8.62556 13.6626 8.86294 13.9V6.69998C8.86294 4.39998 12.5629 4.39998 12.5629 6.69998V10.1C12.7629 9.99998 12.8629 9.99998 13.0629 9.99998H13.263C13.663 9.99998 14.0629 10.1 14.3629 10.4C14.6629 10.2 15.0629 9.99998 15.4629 9.99998H15.6629C16.3629 9.99998 16.8629 10.4 17.1629 10.9L17.163 10.9C17.463 10.8 17.7629 10.7 18.0629 10.7C18.4629 10.7 18.963 10.9 19.263 11.2ZM10.0629 20.8H17.3629V18.9C17.3629 18.8 17.3629 18.6 17.4629 18.5C18.2629 17.2 18.6629 15.1 18.6629 12.6C18.6629 12.4 18.5629 12.2 18.4629 12.1C18.1629 11.8 17.4629 11.8 17.4629 12.6V13.1C17.4629 13.4 17.1629 13.7 16.8629 13.7C16.5629 13.7 16.263 13.4 16.263 13.1V11.7C16.263 11.4 16.063 11.2 15.763 11.2H15.5629C15.2629 11.2 15.0629 11.4 15.0629 11.7V13.1C15.0629 13.4 14.7629 13.7 14.4629 13.7C14.1629 13.7 13.8629 13.4 13.8629 13.1V11.7C13.8629 11.4 13.6629 11.2 13.3629 11.2H13.1629C12.8629 11.2 12.6629 11.4 12.6629 11.7V13.1C12.6629 13.4 12.3629 13.7 12.0629 13.7C11.7629 13.7 11.4629 13.4 11.4629 13.1V6.69998C11.4629 6.09998 10.863 6.09998 10.763 6.09998C10.663 6.09998 10.0629 6.19998 10.0629 6.69998V14.9C10.0629 15.2 9.86294 15.5 9.56294 15.6C9.26294 15.7 8.96295 15.6 8.76295 15.4C8.76295 15.3 8.06295 14.6 6.96295 13.8C6.36295 13.4 5.96294 13.4 5.56294 13.9C5.46295 14 5.46295 14.1999 5.46295 14.2999V14.3C5.46295 14.5 5.56295 14.6 5.66295 14.7C6.12131 15.0056 6.63803 15.4278 7.07936 15.7885L7.07937 15.7885C7.21574 15.9 7.34492 16.0056 7.46295 16.1C8.96295 17.3 9.86294 19 10.0629 20.8ZM13.363 7.1C13.363 7.4 13.663 7.7 13.963 7.7H15.163C15.463 7.7 15.763 7.4 15.763 7.1C15.763 6.8 15.463 6.5 15.163 6.5H13.963C13.663 6.5 13.363 6.7 13.363 7.1ZM7.16304 7.7H5.96304C5.66304 7.7 5.36304 7.4 5.36304 7.1C5.36304 6.8 5.66304 6.5 5.96304 6.5H7.16304C7.46304 6.5 7.76305 6.8 7.76305 7.1C7.76305 7.4 7.46304 7.7 7.16304 7.7ZM7.56301 4.9C7.66301 5 7.86302 5.1 7.96302 5.1C8.06302 5.1 8.26301 5 8.36301 4.9C8.56301 4.7 8.56301 4.3 8.36301 4.1L7.66302 3.4C7.46302 3.2 7.06301 3.2 6.86301 3.4C6.66301 3.6 6.66301 4 6.86301 4.2L7.56301 4.9ZM13.663 4.80001C13.563 4.90001 13.463 5 13.263 5C13.063 5 12.963 5 12.863 4.8C12.663 4.6 12.663 4.2 12.863 4L13.463 3.4C13.663 3.2 14.063 3.2 14.263 3.4C14.463 3.6 14.463 4 14.263 4.2L13.663 4.8L13.663 4.80001Z"
          fill="currentColor"
        />
      </svg>
    ),

    spinner: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 135 135"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <path d="M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 67 67"
            to="-360 67 67"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </path>
        <path d="M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z">
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 67 67"
            to="360 67 67"
            dur="8s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    ),

    redx: (
      <svg
        className={`${baseClass} ${className} h-6 w-6 text-red-600`}
        stroke="currentColor"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    ),

    error: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${baseClass} ${className} text-red-600`}
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
        />
      </svg>
    ),

    warning: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    ),

    code: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <rect width="24" height="24" fill="none" rx="0" ry="0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.50015 21.6001H19.5001C20.3801 21.6001 21.1001 20.8801 21.1001 20.0001V7.41015C21.1001 6.99015 20.9301 6.58015 20.6301 6.28015L17.2201 2.87015C16.9201 2.57015 16.5201 2.40015 16.0901 2.40015H4.50015C3.62015 2.40015 2.90015 3.12015 2.90015 4.00015V20.0001C2.90015 20.8801 3.62015 21.6001 4.50015 21.6001ZM4.10015 4.00015C4.10015 3.78015 4.28015 3.60015 4.50015 3.60015H16.0901C16.1901 3.60015 16.3001 3.65015 16.3701 3.72015L19.7801 7.13015C19.8601 7.20015 19.9001 7.30015 19.9001 7.41015V20.0001C19.9001 20.2201 19.7201 20.4001 19.5001 20.4001H4.50015C4.28015 20.4001 4.10015 20.2201 4.10015 20.0001V4.00015ZM10.1201 17.5001C10.0501 17.5001 9.98008 17.4901 9.91008 17.4601C9.60008 17.3401 9.45008 16.9901 9.56008 16.6801L13.3201 6.88005C13.4401 6.57005 13.7901 6.42005 14.0901 6.53005C14.4001 6.65005 14.5501 7.00005 14.4401 7.31005L10.6801 17.1101C10.5901 17.3501 10.3601 17.5001 10.1201 17.5001ZM14.9301 15.57C15.0401 15.69 15.2001 15.75 15.3501 15.75C15.5001 15.75 15.6601 15.69 15.7801 15.56L18.9301 12.41C19.1601 12.17 19.1601 11.79 18.9301 11.56L15.7801 8.41005C15.5401 8.18005 15.1601 8.18005 14.9301 8.41005C14.7001 8.65005 14.7001 9.03005 14.9301 9.26005L17.6601 11.99L14.9301 14.72C14.7001 14.96 14.7001 15.34 14.9301 15.57ZM8.22997 15.5701C8.33997 15.6901 8.49997 15.7501 8.64997 15.7501C8.79997 15.7501 8.95997 15.6901 9.07997 15.5801C9.30997 15.3401 9.30997 14.9601 9.07997 14.7301L6.34997 12.0001L9.07997 9.27006C9.30997 9.03006 9.30997 8.65006 9.07997 8.42006C8.83997 8.19006 8.45997 8.19006 8.22997 8.42006L5.07997 11.5701C4.84997 11.8101 4.84997 12.1901 5.07997 12.4201L8.22997 15.5701Z"
          fill="currentColor"
        />
      </svg>
    ),

    checkmark: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M5 13l4 4L19 7"
        />
      </svg>
    ),

    downArrow: (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={lineWidth}
        strokeLinecap="round"
        fill="none"
        fillRule="evenodd"
        preserveAspectRatio="xMidYMid meet"
        className={`${baseClass} ${className}`}
      >
        <path d="M15 10.5l-3 3-3-3" />
      </svg>
    ),

    hourglass: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          stroke={color}
          fill=""
          d="M6 2V6.88C6 7.65 6.36 8.38 6.98 8.85L10.5 11.5C11.39 12.17 12.61 12.17 13.5 11.5L17.02 8.85C17.64 8.38 18 7.66 18 6.88V2H6Z"
        />
        <path
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          stroke={color}
          fill=""
          d="M18 22V17.12C18 16.35 17.64 15.62 17.02 15.15L13.5 12.5C12.61 11.83 11.39 11.83 10.5 12.5L6.98 15.15C6.36 15.62 6 16.34 6 17.12V22H18Z"
        />
        <path
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          stroke={color}
          d="M15.5 22H8.5C8.5 21.45 8.95 21 9.5 21H14.5C15.05 21 15.5 21.45 15.5 22Z"
        />
        <path
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          stroke={color}
          d="M4.75 2H19.25"
        />
        <path
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1"
          stroke={color}
          d="M4.75 22H19.25"
        />
      </svg>
    ),

    refresh: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}
        className={`${baseClass} ${className}`}
      >
        <path
          fill="currentColor"
          d="M21.7545 14.2243C21.8784 13.6861 21.5425 13.1494 21.0043 13.0255C20.4661 12.9016 19.9293 13.2374 19.8054 13.7757C19.2633 16.1307 17.6891 18.0885 15.5897 19.1471C14.5148 19.6889 13.2886 20 11.9999 20C9.44375 20 7.49521 18.8312 5.64918 16.765L8.41421 14H2V20.4142L4.23319 18.181C6.29347 20.4573 8.71647 22 11.9999 22C13.6113 22 15.145 21.611 16.4901 20.9329L16.4902 20.9329C19.1108 19.6115 21.0766 17.1692 21.7545 14.2243Z"
          clipRule="evenodd"
          fillRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M2.24553 9.77546C2.12164 10.3137 2.45752 10.8504 2.99573 10.9743C3.53394 11.0982 4.07067 10.7623 4.19456 10.2241C4.73668 7.86902 6.31094 5.91126 8.41029 4.85269C9.48518 4.31081 10.7114 3.99978 12.0001 3.99978C14.5563 3.99978 16.5048 5.16858 18.3508 7.23472L15.5858 9.99976H22V3.58554L19.7668 5.81873C17.7065 3.54248 15.2835 1.99978 12.0001 1.99978C10.3887 1.99978 8.85498 2.38873 7.50989 3.06683L7.50981 3.06687C4.88916 4.3883 2.92342 6.83054 2.24553 9.77546Z"
          clipRule="evenodd"
          fillRule="evenodd"
        />
      </svg>
    ),

    price: (
      <svg
        height={size}
        className={`${baseClass} ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeWidth={lineWidth}
      >
        <path d="M7 3h5a1.99 1.99 0 0 1 1.414.586l7 7a2 2 0 0 1 0 2.828l-7 7a2 2 0 0 1-2.828 0l-7-7A1.994 1.994 0 0 1 3 12V7a4 4 0 0 1 4-4Z" />
        <path d="M11.118 6.981c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2M11.118 6.981c1.11 0 2.08.402 2.599 1M11.118 6.981v-1M11.118 14.981v1M11.118 14.981c-1.11 0-2.08-.402-2.6-1" />
      </svg>
    ),

    logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 32"
        className={`${baseClass} ${className}`}
      >
        <path
          fill="#FFFFFF"
          d="M63.994 23.638c0 4.79-3.89 7.293-9.516 7.293h-8.821V5.924h8.092c5.314 0 9.308 2.327 9.308 7.016a5.218 5.218 0 0 1-3.196 4.861 6.172 6.172 0 0 1 4.133 5.837Zm-10.037-7.293a7.527 7.527 0 0 0 2.015-.21 2.73 2.73 0 0 0 1.667-2.743c0-2.084-1.424-3.195-3.542-3.195h-3.334v6.148Zm-3.194 10.313h3.959c2.118 0 3.785-1.18 3.785-3.368a3.179 3.179 0 0 0-3.439-3.334h-4.305ZM86.1 12.072a15.016 15.016 0 0 0-6.911-1.737 7.888 7.888 0 0 0-8.266 8.091 7.805 7.805 0 0 0 8.092 8.094 15.852 15.852 0 0 0 7.259-1.736v4.965a17.238 17.238 0 0 1-7.641 1.669 12.73 12.73 0 0 1-13.058-12.992A12.791 12.791 0 0 1 78.807 5.437 15.368 15.368 0 0 1 86.1 7.174Zm4.932 1.493v-5.21h5.037v5.21h4.62v4.064h-4.62v6.982c0 1.838 1.076 2.466 2.223 2.466a6.989 6.989 0 0 0 2.952-.73v4.27a10.76 10.76 0 0 1-4.412.8c-2.743 0-5.418-1.287-5.8-4.932-.034-.557-.103-1.148-.103-1.773v-7.083h-2.397v-4.064Zm30.884 8.682a9.256 9.256 0 0 1-18.512 0 9.256 9.256 0 0 1 18.512 0Zm-4.898 0c0-2.882-1.909-4.79-4.375-4.79s-4.342 1.908-4.342 4.79c0 2.884 1.876 4.793 4.342 4.793s4.375-1.909 4.375-4.793Zm25.662 0a9.256 9.256 0 0 1-18.51 0 9.256 9.256 0 0 1 18.51 0Zm-4.896 0c0-2.882-1.91-4.79-4.376-4.79s-4.342 1.908-4.342 4.79c0 2.884 1.876 4.793 4.342 4.793s4.376-1.909 4.376-4.793Zm7.626-16.323h5.175v18.893c0 1.598.694 2.155 1.736 2.155a4.893 4.893 0 0 0 1.737-.348v4.27a8.963 8.963 0 0 1-3.299.523c-2.952 0-5.349-1.493-5.349-5.452Zm16.052 18.096c-3.23-.905-5.522-2.26-5.522-5.628 0-3.229 2.57-5.313 6.599-5.313a14.891 14.891 0 0 1 5.626 1.077v4.446a13.15 13.15 0 0 0-4.411-1.287 6.028 6.028 0 0 0-1.597.07c-.73.14-1.459.487-1.459 1.25 0 .869.868 1.321 2.71 1.876 3.958 1.111 5.833 2.502 5.833 5.627 0 3.334-2.743 5.28-7.154 5.28a14.643 14.643 0 0 1-5.904-1.148v-4.548a14.405 14.405 0 0 0 5.834 1.595c1.286 0 2.466-.345 2.466-1.389 0-.936-1.042-1.317-3.022-1.908Z"
        />
        <path
          fill="currentColor"
          d="M174.577 26.462a2.355 2.355 0 0 1 2.591 2.495 2.593 2.593 0 0 1-5.182 0 2.355 2.355 0 0 1 2.591-2.495Zm7.787-13.418a2.355 2.355 0 0 1 2.592 2.495 2.594 2.594 0 0 1-5.184 0 2.355 2.355 0 0 1 2.592-2.495Zm-2.47 18.045v-12.11h4.94v12.11Zm6.518-6.057a6.665 6.665 0 1 1 6.66 6.42 6.34 6.34 0 0 1-6.66-6.42Zm4.602 0a2.077 2.077 0 1 0 4.117 0 2.077 2.077 0 1 0-4.117 0ZM19.755 8.24a3.755 3.755 0 0 1-2.96 1.09 4.478 4.478 0 0 0-.524-.02c-.22 0-.44.01-.655.031a6.787 6.787 0 0 0-6.09 7.553.924.924 0 0 0 .879.664h.011a.892.892 0 0 0 .633-.27l2.156-2.157a1.75 1.75 0 0 1 1.208-.487 1.723 1.723 0 0 1 1.191.477l1.641 1.648a1.706 1.706 0 0 1 0 2.408l-2.152 2.152a.898.898 0 0 0-.213.945.878.878 0 0 0 .743.586 4.417 4.417 0 0 0 .673.031c.18 0 .36-.007.535-.02a6.795 6.795 0 0 0 6.236-7.297 3.747 3.747 0 0 1 1.078-2.944l6.16-6.16a.808.808 0 0 0-.011-1.153L26.98 2.133a.808.808 0 0 0-1.131.011Z"
        />
        <path
          fill="currentColor"
          d="m31.908 30.617-8.328-8.375a9.48 9.48 0 0 1-3.898 3.187 3.992 3.992 0 0 1-1.611.34H7.376a.807.807 0 0 1-.807-.808V14.336a3.901 3.901 0 0 1 .344-1.62 9.83 9.83 0 0 1 1.41-2.18 9.638 9.638 0 0 1 1.864-1.733L1.788.497a.53.53 0 0 0-.683-.136.597.597 0 0 0-.41.615v30.051a.684.684 0 0 0 .683.683H31.43a.656.656 0 0 0 .615-.41.53.53 0 0 0-.137-.683Z"
        />
      </svg>
    ),

    pages: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={lineWidth}
          d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
        />
      </svg>
    ),

    addresses: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={lineWidth}
        stroke="currentColor"
        width={size}
        height={size}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
        />
      </svg>
    ),

    gear: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={lineWidth}
        stroke="currentColor"
        width={size}
        height={size}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    ),

    logout: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={lineWidth}
        stroke="currentColor"
        width={size}
        height={size}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
        />
      </svg>
    ),

    customerGroup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={lineWidth}
        stroke="currentColor"
        width={size}
        height={size}
        className={`${baseClass} ${className}`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
        />
      </svg>
    ),
  }[name]
}

export default SVG
